import script from "./objection-handle.vue?vue&type=script&setup=true&lang=js"
export * from "./objection-handle.vue?vue&type=script&setup=true&lang=js"

import "./objection-handle.vue?vue&type=style&index=0&id=00c7dfd4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00c7dfd4"]])

export default __exports__